import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Feature, FeatureCollection } from '../../models';
import * as IconFactory from '../../services/icon.factory';

@Component({
    selector: 'kp-map-select-feature',
    templateUrl: './kp-map-select-feature.component.html',
    styleUrls: ['./kp-map-select-feature.component.scss'],
})
export class KpMapSelectFeatureComponent implements OnInit {
    @Input() data: FeatureCollection;

    @Output() close: EventEmitter<void> = new EventEmitter();
    @Output() select: EventEmitter<Feature> = new EventEmitter();

    icons = {
        close: undefined,
    };

    constructor(private domSanitizer: DomSanitizer) {
        // Have factory create the icons for the UI
        for (const key of Object.keys(this.icons)) {
            this.icons[key] = domSanitizer.bypassSecurityTrustUrl(IconFactory.dataUrlFromIconName(key));
        }
    }

    ngOnInit(): void {
        // no implementation
    }

    requestClose() {
        this.close.emit();
    }
    requestSelect(feature: Feature): void {
        this.select.emit(feature);
    }
}
